var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isValidUrl)?_c('div',[_vm._v(_vm._s(_vm.url))]):_vm._e(),(_vm.isValidUrl)?_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.url))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }